const _excluded = ["className", "children", "testId"],
  _excluded2 = ["className", "children", "testId"],
  _excluded3 = ["className", "children", "testId"],
  _excluded4 = ["className", "children", "testId"],
  _excluded5 = ["as", "children", "before", "after", "className", "tooltip", "intent", "disabled", "testId"],
  _excluded6 = ["id", "as", "children", "before", "className", "items", "collapsed", "onClick", "testId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import cn from 'classnames';
import { WideArrowDownward, WideArrowUpward } from "../../icons";
import { ConditionalWrapper } from "../ConditionalWrapper";
import { useIntentBehavior } from "../IntentBehavior";
import { Tooltip } from "../Tooltip";
import styles from "./Sidebar.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Sidebar(props) {
  const {
      className,
      children,
      testId
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, rest), {}, {
    className: cn(styles.root, className),
    "data-testid": testId,
    children: children
  }));
}
Sidebar.Header = SidebarHeader;
Sidebar.Content = SidebarContent;
Sidebar.Footer = SidebarFooter;
Sidebar.Item = SidebarItem;
Sidebar.Group = SidebarGroup;

/** Add this class to the SidebarItem to give it an active look. */
const SIDEBAR_ITEM_ACTIVE_CLASS = styles.active;
function SidebarHeader(props) {
  const {
      className,
      children,
      testId
    } = props,
    rest = _objectWithoutProperties(props, _excluded2);
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, rest), {}, {
    className: cn(styles.header, className),
    "data-testid": testId,
    children: children
  }));
}
function SidebarContent(props) {
  const {
      className,
      children,
      testId
    } = props,
    rest = _objectWithoutProperties(props, _excluded3);
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, rest), {}, {
    className: cn(styles.content, className),
    "data-testid": testId,
    children: children
  }));
}
function SidebarFooter(props) {
  const {
      className,
      children,
      testId
    } = props,
    rest = _objectWithoutProperties(props, _excluded4);
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, rest), {}, {
    className: cn(styles.footer, className),
    "data-testid": testId,
    children: children
  }));
}
function SidebarItem(props) {
  const {
      as,
      children,
      before,
      after,
      className,
      tooltip,
      intent,
      disabled,
      testId
    } = props,
    rest = _objectWithoutProperties(props, _excluded5);
  const {
    getDisabled,
    getTooltip
  } = useIntentBehavior();
  const disabledFromIntent = intent ? getDisabled(intent) : false;
  const tooltipFromIntent = intent ? getTooltip(intent) : null;
  const hasTooltip = !!(tooltip !== null && tooltip !== void 0 && tooltip.title) || !!tooltipFromIntent;
  const RootElement = as || 'button';
  return /*#__PURE__*/_jsx(ConditionalWrapper, {
    condition: hasTooltip,
    wrapper: children => /*#__PURE__*/_jsx(Tooltip, _objectSpread(_objectSpread({
      placement: "top"
    }, tooltip || {
      title: tooltipFromIntent
    }), {}, {
      children: /*#__PURE__*/_jsx("div", {
        className: cn(styles.wrapper, className),
        "data-testid": testId && "".concat(testId, "-wrapper"),
        children: children
      })
    })),
    children: /*#__PURE__*/_jsxs(RootElement, _objectSpread(_objectSpread({}, rest), {}, {
      disabled: disabledFromIntent || disabled,
      className: cn(styles.item, className),
      "data-testid": testId,
      children: [before && /*#__PURE__*/_jsx("span", {
        className: styles.itemPrefix,
        children: before
      }), children && /*#__PURE__*/_jsx("span", {
        className: styles.itemContent,
        children: children
      }), after && /*#__PURE__*/_jsx("span", {
        className: styles.itemSuffix,
        "data-testid": testId && testId + '-suffix',
        children: after
      })]
    }))
  });
}
function SidebarGroup(props) {
  const {
      id,
      as,
      children,
      before,
      className,
      items,
      collapsed,
      onClick,
      testId
    } = props,
    rest = _objectWithoutProperties(props, _excluded6);
  const RootElement = as || 'button';
  return /*#__PURE__*/_jsxs("div", {
    className: cn(styles.group, collapsed ? styles.collapsed : ''),
    children: [/*#__PURE__*/_jsxs(RootElement, _objectSpread(_objectSpread({}, rest), {}, {
      id: id,
      className: cn(styles.groupToggle, className),
      onClick: onClick,
      "data-testid": testId,
      children: [before && /*#__PURE__*/_jsx("span", {
        className: styles.itemPrefix,
        children: before
      }), children && /*#__PURE__*/_jsx("span", {
        className: styles.itemContent,
        children: children
      }), /*#__PURE__*/_jsx("span", {
        className: styles.itemSuffix,
        "data-testid": testId && testId + '-suffix',
        children: collapsed ? /*#__PURE__*/_jsx(WideArrowDownward, {
          width: 18,
          height: 18
        }) : /*#__PURE__*/_jsx(WideArrowUpward, {
          width: 18,
          height: 18
        })
      })]
    })), items]
  });
}
export { Sidebar, SidebarHeader, SidebarContent, SidebarFooter, SidebarItem, SidebarGroup, SIDEBAR_ITEM_ACTIVE_CLASS };